import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

export const UbsInvoicePdfSchema = z.object({
  pdfBlob: z.instanceof(Blob),
  filename: z.string(),
})

export type UbsInvoicePdf = ZodInfer<typeof UbsInvoicePdfSchema>
